import { useStateParams } from 'apps/app/src/hooks/use-state-params';
import { deserializeEnumParam } from 'apps/app/src/utils/params-formatting';
import type { ReportType } from '../reports-page-types/report-type';
import { REPORT_TYPES } from '../reports-page-types/report-type';
export const DEFAULT_REPORT_TYPE = REPORT_TYPES.ALL_REPORTS;

export function useReportTypeStateParam() {
  return useStateParams<ReportType>(DEFAULT_REPORT_TYPE, 'reportType', (stringVal) => stringVal, deserializeEnumParam(REPORT_TYPES));
}